<div mat-dialog-content class="flex-grow p-0">
    <div class="flex flex-col h-full">
        <mat-form-field class="flex-none">
            <input matInput
                   #filter
                   placeholder="Search Skills">
        </mat-form-field>
        <mat-selection-list (selectionChange)="onSelectionChange($event)" class="flex-grow">
            <cdk-virtual-scroll-viewport itemSize="50" class="h-full overflow-x-hidden" >
                <mat-list-option *cdkVirtualFor="let skill of (skillList | skillSearch:filter.value); templateCacheSize: 0"
                                 [value]="skill"
                                 [selected]="selection.isSelected(skill)"
                                 togglePosition="before"
                >
                    <div class="flex flex-row justify-items-start">
                        <div  class="flex items-center">
                            <mat-icon class="p-5" matTooltip="{{skill.customMediaTypeName}}">{{skill.mediaTypeIcon}}</mat-icon>
                        </div>
                        <div class="flex-col justify-items-center">
                            <div class="font-bold">{{skill.skillName}}</div>
                            <div class="font-light">{{skill.campaignName}}</div>
                        </div>
                    </div>
                </mat-list-option>
            </cdk-virtual-scroll-viewport>
        </mat-selection-list>
    </div>
</div>
<div class="flex flex-row justify-around p-1">
    <button mat-raised-button color="accent" (click)="onDismiss()" mat-dialog-close>Cancel </button>
    <button mat-raised-button color="primary" (click)="onConfirm()">Add Skills
    </button>
</div>
